class Share {
  static init(...parameters) {
    return new Share(...parameters);
  }

  constructor(container) {
    const shareLinks = container.querySelectorAll('.share-links a');
    let shareWindow = null;

    [...shareLinks].forEach((link) => {
      if (link.classList.contains('mail')) {
        return;
      }
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const shareLink = e.currentTarget.href;
        const windowOptions = 'width=600, height=500, menubar=no, centerscreen=yes';
        if (shareWindow === null || shareWindow.closed) {
          shareWindow = window.open(shareLink, 'shareWindow', windowOptions);
        } else {
          shareWindow.location = shareLink;
          shareWindow.focus();
        }
      });
    });
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-share', Share.init);
}
